// extracted by mini-css-extract-plugin
export var containerXxl = "footer-module--container-xxl--b8073";
export var copyright = "footer-module--copyright--060f5";